export const colors = {
  buttons: {
    primary: '#377B5D',
    primaryHover: '#2E674E',
    secondary: '#76A691',
    secondaryHover: '#598773',
    dark: '#1D9962',
    darkHover: '#17794E',
    light: '#44B985',
    text: '#FFFFFF',
  },
  text: {
    dark: '#212121',
    accent: '#55906A',
    light: '#415446',
    active: '#118841',
  },
  background: {
    light: '#FEFFFB',
    dark: '#EBF3E2',
    accent: '#F5FBEF',
    medium: '#FDFFFA',
    transparent: '#EBF3E2',
    tooltip: '#DCEDDB',
  },
  elements: {
    primary: '#D3E7BE',
    secondary: '#C3E4A1',
    accent: '#9DAB85',
    dark: '#C9D3B6',
    skeletonPrimary: '#C9C7B9',
    skeletonSecondary: '#F6F3E2',
  },
  border: {
    primary: '#DDDCD3',
  },
  gradient: {
    fade: 'linear-gradient(90deg, #FDFFF7 40.38%, rgba(253, 255, 247, 0) 100%)',
  },
  accent: {
    success: '#387545',
    error: '#E5373A',
    soft: '#FFEBC3',
  },
  tags: {
    processing: '#88D5ED',
    success: '#BFE1A8',
    reject: '#FFA089',
    transfer: '#FFD889',
    mint: '#A8C8FF',
    text: '#3E3E3E',
  },
};
